import { useNavigate } from "react-router-dom";
import { MenuItem } from "primereact/menuitem";
import { Profile } from "./appSlice";
import { Header } from "@kosmos/shared";
import { useAppSelector } from '../hooks/hooks';
import { useGetConfigQuery } from '../app/apiSlice';

export const HeaderContainer = ({ profile }: { profile: Profile | undefined }) => {
  const navigate = useNavigate();
  const {data : config} = useGetConfigQuery();
  const initials =  `${profile?.given_name?.[0]?.toUpperCase() || ''}${profile?.family_name?.[0]?.toUpperCase() || ''}`;;
  const fullname = `${profile?.given_name ?? ''} ${profile?.family_name ?? ''}`
  const plateformLevel = useAppSelector((state) => state.app.config.platformLevel);


    const profileLinks: MenuItem[] = profile
    ? [
        {
          label: "Profil",
          icon: "pi pi-user",
          command: () => {
            navigate("/profile");
          },
        },{
          label: "About",
          icon: "pi pi-shield",
          command: () => {
            navigate("/about");
          },
        },
      ]
    : [];

  return (
    <Header
      appName="Datapipeline"
      portalUrl={config?.portailUrl ?? ""}
      initials={initials}
      fullName={fullname}
      level={plateformLevel}
      iconsBaseUrl="/v1/icons"
      profileLinks={profileLinks}
      logoutFn={() => {
        window.location.href = "/api/logout";
      }}
    ></Header>
  );
};
